import React, { Fragment, useState, useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import Spinner from 'react-bootstrap/Spinner';
import { useSelector } from 'react-redux';
import { checkSubscribtionDetails } from '../../../store/actions/SubscribtionActions';

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState("");
  const [addModal, setAddModal] = useState(false);
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  const loading = useSelector(state => state.global.showLoading);
  const userType = useSelector(state => state.auth.userType);
  const subscriptionStaus = useSelector(state => state.subscribtion.subscriptionStaus);

  useEffect(() => {
    dispatch(checkSubscribtionDetails(history));
  }, [location]);

  useEffect(() => {
    setAddModal(subscriptionStaus ?? false);
  }, [subscriptionStaus]);

  const onConfirmHandler = () => {
    let getData = localStorage.getItem('userDetails');
    let obj = {
      "_id": JSON.parse(getData)._id,
      "token": JSON.parse(getData).token,
      "company_id": JSON.parse(getData).company_id,
      "country": JSON.parse(getData).country,
      "country_code": JSON.parse(getData).country_code,
      "email": JSON.parse(getData).email,
      "status": JSON.parse(getData).status,
      "user_type": JSON.parse(getData).user_type,
      "system_admin": JSON.parse(getData).system_admin,
      "expired": 0,
    }
    history.push({
      pathname: '/page-subscribtions',
      state: obj
    });
  }

  return (
    <Fragment>
      {loading ?
        <div className="loading-view">
          <div className="loading-icon-view">
            <Spinner
              as="span"
              animation="border"
              size="lg"
              role="status"
              aria-hidden="true"
            />
          </div>
        </div>
        : null}

      <NavHader />
      <Header
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar />

      <Modal
        className="fade bd-example-modal-sm"
        size="md"
        show={addModal}
      >
        <div className='expired-subcription-plan'>

          {parseInt(userType) != 1 && (<>
            <h3>Didn’t renew
              the subscription. Contact your Administrator.
            </h3>
          </>)}

          {parseInt(userType) == 1 && (<>
            <h2>Select a plan to continue.</h2>
            <p>Please take a plan to continue using Clockmenow</p>
            <button type="button"
              onClick={() => onConfirmHandler()}
              className="subscription-plan-btn">
              Go to Subscription Plan
            </button>
          </>)}

        </div>
      </Modal>
    </Fragment>
  );
};

export default JobieNav;
